import React from 'react';
import Tick from '../assets/Tick';

export default function ({ children, value, onChange, onSubmit, error, signedUp, buttonText }) {
  return (
    <form onSubmit={onSubmit}>
      <label>
        { children }
        <input
          disabled={signedUp}
          type="email"
          value={value}
          onChange={onChange}
          placeholder="Email address"
          className={error ? 'has-error' : null}
        />
        <button className={signedUp ? 'complete' : null} type="submit">
          {signedUp
            ? <Tick fill="#fff"/>
            : buttonText
          }
        </button>
      </label>
    </form>
  )
}



// WEBPACK FOOTER //
// ./src/Components/Form/SignUp.js